export default {
  id: 'oracle-manage',
  instructionInfo: [
    '预言机是一种将现实世界数据引入区块链的机制，它允许区块链智能合约获取和使用在区块链外部生成的数据。例如在金融市场中，预言机可以用于提供金融市场数据，如股票价格、外汇汇率、商品价格等，供智能合约使用。这样，智能合约可以基于实时市场数据执行相应的操作，例如触发交易或进行金融衍生品交易。预言机类似一个桥梁，一边用来获取现实中的各种实时数据，一边提供入口供智能合约获取需要的数据，从而实现链上与链下数据的交互。'
  ]
}
